import { render, staticRenderFns } from "./cl-tab.vue?vue&type=template&id=87cb9d4c&scoped=true&"
import script from "./cl-tab.vue?vue&type=script&lang=ts&"
export * from "./cl-tab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cb9d4c",
  null
  
)

export default component.exports